import { combineReducers } from "redux";
import parameter from "./parameter";
import transaction from "./transaction";
import configuration from "./configuration";
import newsAndAds from "./newsAndAds";
import filterOptions from "./filterOptions";

const paramsReducer = combineReducers({
  parameter,
  transaction,
  configuration,
  newsAndAds,
  filterOptions,
});

export default paramsReducer;
